import { jsxs, jsx } from "react/jsx-runtime";
import iconTalkSvg from "../assets/print/icon-talk.svg.js";
import noteSvg from "../assets/print/note.svg.js";
import "../components/quiz-types/shared/quiz-blank.js";
import { KatexText } from "../components/quiz-types/shared/katex-text.js";
import "react";
import "react-i18next";
import "../components/quiz-types/shared/quiz-style-context.js";
import "../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../context/DevToolsContext.js";
import "../utils/quiz-parser.js";
import { STEP_CONFIGS, STEP4_LAYOUT } from "./constants.js";
function Step4Section({ questions, showTitle = true }) {
  const config = STEP_CONFIGS[3];
  return /* @__PURE__ */ jsxs("div", { style: { position: "relative", display: "flex", justifyContent: "center" }, children: [
    showTitle && /* @__PURE__ */ jsx("div", { style: { position: "absolute", left: 72, top: -34, zIndex: 1 }, children: /* @__PURE__ */ jsx("img", { src: config.svg, alt: "", width: config.svgWidth, height: config.svgHeight }) }),
    /* @__PURE__ */ jsx(
      "div",
      {
        style: {
          width: 650,
          background: "#FFE4E4",
          borderRadius: 16,
          padding: "40px 40px 32px"
        },
        children: questions.map((question, idx) => /* @__PURE__ */ jsxs("div", { style: { marginBottom: idx < questions.length - 1 ? 32 : 0 }, children: [
          /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "flex-start", gap: 6, marginBottom: 24 }, children: [
            /* @__PURE__ */ jsx("img", { src: iconTalkSvg, alt: "", width: 39, height: 24, style: { flexShrink: 0, marginTop: 4 } }),
            /* @__PURE__ */ jsx("span", { style: { fontSize: 16, fontWeight: 600, lineHeight: 1.875, color: "#131313" }, children: /* @__PURE__ */ jsx(KatexText, { text: question }) })
          ] }),
          /* @__PURE__ */ jsx("div", { style: { display: "flex", justifyContent: "center" }, children: /* @__PURE__ */ jsx("img", { src: noteSvg, alt: "", width: "100%", height: STEP4_LAYOUT.noteHeight, style: { maxWidth: STEP4_LAYOUT.noteWidth } }) })
        ] }, idx))
      }
    )
  ] });
}
export {
  Step4Section
};
//# sourceMappingURL=Step4Section.js.map
